import { render, staticRenderFns } from "./TrainingMonitor.vue?vue&type=template&id=710a7246&scoped=true"
import script from "./TrainingMonitor.vue?vue&type=script&lang=js"
export * from "./TrainingMonitor.vue?vue&type=script&lang=js"
import style0 from "./TrainingMonitor.vue?vue&type=style&index=0&id=710a7246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710a7246",
  null
  
)

export default component.exports